<template>
  <StyledIcon :iconsColor="theme.iconColor"><slot></slot></StyledIcon>
</template>

<script>
import styled from "vue-styled-components";

const wrapperProps = { iconsColor: String };

const StyledIcon = styled("span", wrapperProps)`
  ${props =>
    props.iconsColor && props.iconsColor !== ""
      ? "svg g{ fill: " + props.iconsColor + "}"
      : ""};
`;

export default {
  name: "styled-icon",
  props: {
    iconsColor: String
  },
  components: {
    StyledIcon
  },
  computed: {
    theme() {
      return {
        iconColor: this.iconsColor
          ? this.iconsColor
          : this.currentTheme().select_color
      };
    }
  }
};
</script>
